var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cards-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Personal-Loans",
    transform: "translate(-429.000000, -253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pl_lfs-02",
    transform: "translate(410.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "payment-due",
    transform: "translate(20.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-warning",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C20,15.5228571 15.5228571,20 10,20 C4.47785714,20 0,15.5228571 0,10 C0,4.47714286 4.47785714,0 10,0 C15.5228571,0 20,4.47714286 20,10 Z",
    id: "Stroke-8",
    stroke: "#cf000f",
    strokeWidth: 2,
    fill: "#cf000f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43076008,4.16666667 L11.5863454,4.16666667 L11.1646586,11.1365042 L8.85095939,11.1365042 L8.43076008,4.16666667 Z M8.33333333,13.5124938 C8.33333333,13.3181799 8.37349398,13.1312366 8.45455898,12.9503237 C8.53488026,12.7714209 8.64941246,12.6132896 8.79518072,12.4765999 C8.94020527,12.3405802 9.11497843,12.2320324 9.32098765,12.1496165 C9.52476573,12.0672006 9.7523427,12.0263277 10,12.0263277 C10.2476573,12.0263277 10.475978,12.0672006 10.6797561,12.1496165 C10.8850216,12.2320324 11.0605385,12.3405802 11.2063067,12.4765999 C11.3513313,12.6132896 11.4651197,12.7714209 11.545441,12.9503237 C11.626506,13.1312366 11.6666667,13.3181799 11.6666667,13.5124938 C11.6666667,13.7068077 11.626506,13.8944211 11.545441,14.0733238 C11.4651197,14.2542368 11.3513313,14.411698 11.2063067,14.5477177 C11.0605385,14.6837374 10.8850216,14.7936253 10.6797561,14.8753711 C10.475978,14.957787 10.2476573,15 10,15 C9.7523427,15 9.52476573,14.957787 9.32098765,14.8753711 C9.11497843,14.7936253 8.94020527,14.6837374 8.79518072,14.5477177 C8.64941246,14.411698 8.53488026,14.2542368 8.45455898,14.0733238 C8.37349398,13.8944211 8.33333333,13.7068077 8.33333333,13.5124938 L8.33333333,13.5124938 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.2501264f.svg";
export { ForwardRef as ReactComponent };